import { lazy } from "react";
import { ASSETGUARD_ACCESS_RIGHTS } from "@/constants/AccessRights";

const AssetGuard_Dashboard_Admin = lazy(() => import("@/pages/AssetGuard/Dashboards/AdminDashboard"));
const AssetGuard_Dashboard_Employee = lazy(() => import("@/pages/AssetGuard/Dashboards/EmployeeDashboard"));

const AssetGuard_Assets = lazy(() => import("@/pages/AssetGuard/Assets/index"));
const AssetGuard_MyAssets = lazy(() => import("@/pages/AssetGuard/MyAssets/index"));

const AssetGuard_Transactions = lazy(() => import("@/pages/AssetGuard/Transactions/index"));
const AssetGuard_Transactions_AgencyTransfers = lazy(() => import("@/pages/AssetGuard/Transactions/AgencyTransfers/index"));
const AssetGuard_Transactions_AssetIssuances = lazy(() => import("@/pages/AssetGuard/Transactions/AssetIssuances/index"));
const AssetGuard_Transactions_AssetRequests = lazy(() => import("@/pages/AssetGuard/Transactions/AssetRequests/index"));
const AssetGuard_Transactions_AssetTransfers = lazy(() => import("@/pages/AssetGuard/Transactions/AssetTransfers/index"));
const AssetGuard_Transactions_AssetAuctions = lazy(() => import("@/pages/AssetGuard/Transactions/AssetAuctions/index"));
const AssetGuard_Transactions_AssetDecommissions = lazy(() => import("@/pages/AssetGuard/Transactions/AssetDecommissions/index"));
const AssetGuard_Transactions_AssetRepairs = lazy(() => import("@/pages/AssetGuard/Transactions/AssetRepairs/index"));
const AssetGuard_Transactions_StolenAssets = lazy(() => import("@/pages/AssetGuard/Transactions/StolenAssets/index"));
const AssetGuard_Transactions_AssetDisposals = lazy(() => import("@/pages/AssetGuard/Transactions/AssetDisposals/index"));

const AssetGuard_Settings = lazy(() => import("@/pages/AssetGuard/StaticData/index"));
const AssetGuard_Settings_AgencyTransferBasis = lazy(() => import("@/pages/AssetGuard/StaticData/AgencyTransferBasis"));
const AssetGuard_Settings_AssetGroups = lazy(() => import("@/pages/AssetGuard/StaticData/AssetGroups/index"));
const AssetGuard_Settings_Agencies = lazy(() => import("@/pages/AssetGuard/StaticData/Agencies/index"));
const AssetGuard_Settings_AssetArticles = lazy(() => import("@/pages/AssetGuard/StaticData/AssetArticles/index"));
const AssetGuard_Settings_AssetTypes = lazy(() => import("@/pages/AssetGuard/StaticData/AssetTypes/index"));
const AssetGuard_Settings_UnitOfMeasures = lazy(() => import("@/pages/AssetGuard/StaticData/UnitOfMeasures/index"));
const AssetGuard_Settings_StorageLocations = lazy(() => import("@/pages/AssetGuard/StaticData/StorageLocations/index"));
const AssetGuard_Settings_DocumentTypes = lazy(() => import("@/pages/AssetGuard/StaticData/DocumentTypes/index"));
const AssetGuard_Settings_Departments = lazy(() => import("@/pages/AssetGuard/StaticData/GovDepartments/index"));
const AssetGuard_Settings_ServiceProviders = lazy(() => import("@/pages/AssetGuard/StaticData/ServiceProviders/index"));
const AssetGuard_Settings_MaintenanceTypes = lazy(() => import("@/pages/AssetGuard/StaticData/MaintenanceTypes/index"));
const AssetGuard_Settings_ReturnReasons = lazy(() => import("@/pages/AssetGuard/StaticData/ReturnReasons/index"));
const AssetGuard_Settings_TransferReasons = lazy(() => import("@/pages/AssetGuard/StaticData/TransferReasons/index"));
const AssetGuard_Settings_DisposalMethods = lazy(() => import("@/pages/AssetGuard/StaticData/DisposalMethods/index"));
const AssetGuard_Settings_AssetConditions = lazy(() => import("@/pages/AssetGuard/StaticData/AssetConditions/index"));

const AssetGuard_Reports = lazy(() => import("@/pages/AssetGuard/Reports/index"));

const AssetGuard_Others_AgencyTransfers = lazy(() => import("@/pages/AssetGuard/Others/AgencyTransfers"));
const AssetGuard_Others_AssetRequests = lazy(() => import("@/pages/AssetGuard/Others/AssetRequests"));
const AssetGuard_Others_AssetIssuances = lazy(() => import("@/pages/AssetGuard/Others/AssetIssuances"));
const AssetGuard_Others_AssetTransfers = lazy(() => import("@/pages/AssetGuard/Others/AssetTransfers"));
const AssetGuard_Others_AssetDisposals = lazy(() => import("@/pages/AssetGuard/Others/AssetDisposals"));
const AssetGuard_Others_AssetAuctions = lazy(() => import("@/pages/AssetGuard/Others/AssetAuctions"));
const AssetGuard_Others_AssetDecommissions = lazy(() => import("@/pages/AssetGuard/Others/AssetDecommissions"));
const AssetGuard_Others_AssetRepairs = lazy(() => import("@/pages/AssetGuard/Others/AssetRepairs"));
const AssetGuard_Others_StolenAssets = lazy(() => import("@/pages/AssetGuard/Others/StolenAssets"));

export var assetGuardRoutes = [

    // ── Dashboards ──────────────────────────────────────────────────────────
    {
        path: "/assetguard/admin-dashboard",
        component: <AssetGuard_Dashboard_Admin />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_ADMIN_DASHBOARD]
    },
    {
        path: "/assetguard/employee-dashboard",
        component: <AssetGuard_Dashboard_Employee />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_EMPLOYEE_DASHBOARD]
    },

    // ── Assets ──────────────────────────────────────────────────────────────
    {
        path: "/assetguard/assets",
        component: <AssetGuard_Assets />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_ASSETS]
    },
    {
        path: "/assetguard/my-assets",
        component: <AssetGuard_MyAssets />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_MYASSETS]
    },

    // ── Transactions (index — accessible if user has any transaction right) ─
    {
        path: "/assetguard/transactions",
        component: <AssetGuard_Transactions />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_APPROVER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_APPROVER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_APPROVER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_APPROVER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_APPROVER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_APPROVER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_APPROVER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_APPROVER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_APPROVER,
        ]
    },

    // ── Transaction pages ────────────────────────────────────────────────────
    {
        path: "/assetguard/transactions/asset-agency-transfers",
        component: <AssetGuard_Transactions_AgencyTransfers />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_APPROVER,
        ]
    },
    {
        path: "/assetguard/transactions/asset-issuances",
        component: <AssetGuard_Transactions_AssetIssuances />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_APPROVER,
        ]
    },
    {
        path: "/assetguard/transactions/asset-requests",
        component: <AssetGuard_Transactions_AssetRequests />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_APPROVER,
        ]
    },
    {
        path: "/assetguard/transactions/asset-transfers",
        component: <AssetGuard_Transactions_AssetTransfers />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_APPROVER,
        ]
    },
    {
        path: "/assetguard/transactions/asset-auctions",
        component: <AssetGuard_Transactions_AssetAuctions />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_APPROVER,
        ]
    },
    {
        path: "/assetguard/transactions/asset-decommissions",
        component: <AssetGuard_Transactions_AssetDecommissions />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_APPROVER,
        ]
    },
    {
        path: "/assetguard/transactions/asset-repairs",
        component: <AssetGuard_Transactions_AssetRepairs />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_APPROVER,
        ]
    },
    {
        path: "/assetguard/transactions/stolen-assets",
        component: <AssetGuard_Transactions_StolenAssets />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_APPROVER,
        ]
    },
    {
        path: "/assetguard/transactions/asset-disposals",
        component: <AssetGuard_Transactions_AssetDisposals />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_REQUESTOR,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_APPROVER,
        ]
    },

    // ── Settings (index — accessible if user has any static data right) ──────
    {
        path: "/assetguard/settings",
        component: <AssetGuard_Settings />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_GOVAGENCIES,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_AGENCIYTRANSFERBASIS,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETARTICLES,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETGROUPS,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETTYPES,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_GOVDEPARTMENTS,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_DOCUMENTTYPES,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_MAINTENANCETYPES,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_RETURNREASONS,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_SERVICEPROVIDERS,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_STORAGELOCATIONS,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_TRANSFERREASONS,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_UNITOFMEASURES,
        ]
    },

    // ── Settings pages ───────────────────────────────────────────────────────
    {
        path: "/assetguard/settings/asset-groups",
        component: <AssetGuard_Settings_AssetGroups />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETGROUPS]
    },
    {
        path: "/assetguard/settings/agency-transfer-basis",
        component: <AssetGuard_Settings_AgencyTransferBasis />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_AGENCIYTRANSFERBASIS]
    },
    {
        path: "/assetguard/settings/agencies",
        component: <AssetGuard_Settings_Agencies />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_GOVAGENCIES]
    },
    {
        path: "/assetguard/settings/asset-articles",
        component: <AssetGuard_Settings_AssetArticles />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETARTICLES]
    },
    {
        path: "/assetguard/settings/asset-types",
        component: <AssetGuard_Settings_AssetTypes />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETTYPES]
    },
    {
        path: "/assetguard/settings/unit-of-measures",
        component: <AssetGuard_Settings_UnitOfMeasures />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_UNITOFMEASURES]
    },
    {
        path: "/assetguard/settings/storage-locations",
        component: <AssetGuard_Settings_StorageLocations />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_STORAGELOCATIONS]
    },
    {
        path: "/assetguard/settings/document-types",
        component: <AssetGuard_Settings_DocumentTypes />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_DOCUMENTTYPES]
    },
    {
        path: "/assetguard/settings/departments",
        component: <AssetGuard_Settings_Departments />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_GOVDEPARTMENTS]
    },
    {
        path: "/assetguard/settings/service-providers",
        component: <AssetGuard_Settings_ServiceProviders />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_SERVICEPROVIDERS]
    },
    {
        path: "/assetguard/settings/maintenance-types",
        component: <AssetGuard_Settings_MaintenanceTypes />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_MAINTENANCETYPES]
    },
    {
        path: "/assetguard/settings/return-reasons",
        component: <AssetGuard_Settings_ReturnReasons />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_RETURNREASONS]
    },
    {
        path: "/assetguard/settings/transfer-reasons",
        component: <AssetGuard_Settings_TransferReasons />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_TRANSFERREASONS]
    },
     {
        path: "/assetguard/settings/asset-conditions",
        component: <AssetGuard_Settings_AssetConditions />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETCONDITIONS]
    },

        {
        path: "/assetguard/settings/disposal-methods",
        component: <AssetGuard_Settings_DisposalMethods />,
        permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_DISPOSALMETHODS]
    },


    // ── Reports ──────────────────────────────────────────────────────────────
    {
        path: "/assetguard/reports",
        component: <AssetGuard_Reports />,
        permissionTypeId: []
    },

    // ── Others (employee-facing views) ───────────────────────────────────────
    {
        path: "/assetguard/others/asset-agency-transfers",
        component: <AssetGuard_Others_AgencyTransfers />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_REQUESTOR,
        ]
    },
    {
        path: "/assetguard/others/asset-requests",
        component: <AssetGuard_Others_AssetRequests />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_REQUESTOR,
        ]
    },
    {
        path: "/assetguard/others/asset-issuances",
        component: <AssetGuard_Others_AssetIssuances />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_REQUESTOR,
        ]
    },
    {
        path: "/assetguard/others/asset-transfers",
        component: <AssetGuard_Others_AssetTransfers />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_REQUESTOR,
        ]
    },
    {
        path: "/assetguard/others/asset-disposals",
        component: <AssetGuard_Others_AssetDisposals />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_REQUESTOR,
        ]
    },
    {
        path: "/assetguard/others/asset-auctions",
        component: <AssetGuard_Others_AssetAuctions />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_REQUESTOR,
        ]
    },
    {
        path: "/assetguard/others/asset-decommissions",
        component: <AssetGuard_Others_AssetDecommissions />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_REQUESTOR,
        ]
    },
    {
        path: "/assetguard/others/asset-repairs",
        component: <AssetGuard_Others_AssetRepairs />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_REQUESTOR,
        ]
    },
    {
        path: "/assetguard/others/stolen-assets",
        component: <AssetGuard_Others_StolenAssets />,
        permissionTypeId: [
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_VIEWER,
            ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_REQUESTOR,
        ]
    },
];